import {
  Camera, LinkSimple, PencilSimple, DownloadSimple, BookOpenText, Stack, ShareNetwork, Sparkle,
  Microphone, Timer, Swap, QrCode, ShoppingCart, ListChecks, PushPin, ShoppingBag,
  Export, CalendarBlank, ForkKnife, CookingPot, Heart, Users, Printer, ChefHat,
} from "@phosphor-icons/react";

// Icons the admin can pick for each home page box (Admin → Site Copy). Keys are stored in the CMS.
export const HOME_ICONS = {
  camera: { Icon: Camera, label: "Camera" },
  link: { Icon: LinkSimple, label: "Link" },
  pencil: { Icon: PencilSimple, label: "Pencil" },
  import: { Icon: DownloadSimple, label: "Import" },
  book: { Icon: BookOpenText, label: "Book" },
  stack: { Icon: Stack, label: "Cookbooks" },
  share: { Icon: ShareNetwork, label: "Share" },
  sparkle: { Icon: Sparkle, label: "Sparkle" },
  mic: { Icon: Microphone, label: "Voice" },
  timer: { Icon: Timer, label: "Timer" },
  swap: { Icon: Swap, label: "Swap" },
  qr: { Icon: QrCode, label: "QR code" },
  cart: { Icon: ShoppingCart, label: "Cart" },
  list: { Icon: ListChecks, label: "Checklist" },
  pin: { Icon: PushPin, label: "Pin" },
  bag: { Icon: ShoppingBag, label: "Bag" },
  export: { Icon: Export, label: "Export" },
  calendar: { Icon: CalendarBlank, label: "Calendar" },
  fork: { Icon: ForkKnife, label: "Fork & knife" },
  pot: { Icon: CookingPot, label: "Cooking pot" },
  heart: { Icon: Heart, label: "Heart" },
  family: { Icon: Users, label: "Family" },
  print: { Icon: Printer, label: "Print" },
  chef: { Icon: ChefHat, label: "Chef hat" },
};

export const pickIcon = (key, fallback) => HOME_ICONS[key]?.Icon || fallback;
